export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const JOB_ROLES = [
  "Accountant", "Administrator", "Agricultural Technician", "Alarm Technician",
  "Architect", "Army Officer", "Auto Electrician", "Barber",
  "Beauty Therapist", "Body Shop Technician", "Boiler Technician", "Bookkeeper",
  "Bricklayer", "Business Analyst", "Business Development Manager", "Buyer",
  "CAD Technician", "Care Worker", "Carpenter", "Chef",
  "Childminder", "Civil Engineer", "Clinical Researcher", "Compliance Officer",
  "Community Development Worker", "Content Creator", "Copywriter", "Customer Service Representative",
  "Cybersecurity Analyst", "Data Analyst", "Delivery Driver", "DevOps Engineer",
  "Electrical Engineer", "Electrician", "Energy Analyst", "Estate Agent",
  "Event Coordinator", "Family Support Worker", "Farm Worker", "Fashion Designer",
  "Financial Advisor", "Financial Analyst", "Fleet Manager", "Fork Lift Operator",
  "Front of House Manager", "Fundraiser", "Gas Engineer", "General Labourer",
  "Graphic Designer", "Hairdresser", "Healthcare Assistant", "Heating Engineer",
  "HGV Driver", "Horticulturalist", "Hotel Receptionist", "Housing Officer",
  "HR Assistant", "HR Manager", "Illustrator", "Insurance Broker",
  "Interior Designer", "IT Support Technician", "Joiner", "Journalist",
  "Kitchen Assistant", "Lab Technician", "Lawyer", "Learning Support Assistant",
  "Lecturer", "Legal Secretary", "Letting Agent", "Logistics Coordinator",
  "Marketing Assistant", "Marketing Manager", "Mechanical Engineer", "Mental Health Worker",
  "MOT Tester", "Mortgage Advisor", "Nail Technician", "Network Engineer",
  "Network Technician", "Nurse", "Nursery Nurse", "Nursery Practitioner",
  "Occupational Therapist", "Painter & Decorator", "Paralegal", "Paramedic",
  "Parts Advisor", "PE Teacher", "Personal Trainer", "Pharmacy Technician",
  "Photographer", "Play Worker", "Plumber", "Policy Officer",
  "PR Executive", "Production Operative", "Product Manager", "Project Manager",
  "Property Manager", "Quality Controller", "Quantity Surveyor", "Radiographer",
  "RAF Technician", "Research Scientist", "Researcher", "Retail Assistant",
  "Roofer", "Sales Executive", "Scaffolder", "School Administrator",
  "Site Manager", "Site Supervisor", "Social Media Manager", "Social Worker",
  "Software Developer", "Solar Panel Installer", "Sous Chef", "Sports Coach",
  "Sports Development Officer", "Store Manager", "Structural Engineer", "Support Worker",
  "Surveyor", "Tax Consultant", "Teacher", "Teaching Assistant",
  "UX / UI Designer", "Vehicle Technician", "Video Editor", "Visual Merchandiser",
  "Volunteer Coordinator", "Waiter / Waitress", "Warehouse Operative",
  "Wind Turbine Technician",
];

export const INDUSTRIES = [
  "Agriculture", "Armed Forces", "Childcare & Early Years", "Construction",
  "Creative & Design", "Education", "Electrical", "Energy & Utilities",
  "Engineering", "Finance", "Government & Public Sector", "Hair & Beauty",
  "Healthcare", "Hospitality", "Legal", "Manufacturing",
  "Media & Marketing", "Motor Trade", "Non-Profit & Charity", "Plumbing & Heating",
  "Real Estate & Property", "Retail", "Science & Research", "Social Care",
  "Sports & Fitness", "Technology", "Telecommunications", "Transport & Logistics",
];

export const SALARY_BRACKETS = [
  "Under 15k", "15k-20k", "20k-25k", "25k-30k",
  "30k-40k", "40k-50k", "50k-60k", "60k+",
];

export const EXPERIENCE_LEVELS = [
  "Under 1 Year", "1-3 Years", "3-5 Years", "5-10 Years", "10-15 Years", "15+ Years",
];

export const UK_REGIONS = [
  "London", "South East", "South West", "East Midlands",
  "West Midlands", "North West", "North East", "Yorkshire",
  "Scotland", "Wales", "Northern Ireland", "East of England",
  "Remote/Anywhere",
];

export const DRIVING_LICENCE_OPTIONS = ["Yes - Full", "Yes - Provisional", "No"];

export const RELOCATE_OPTIONS = ["Yes", "No"];

export const JOB_TYPES = ["Full-time", "Part-time"];

export const CONTRACT_TYPES = [
  "Permanent", "Fixed-term", "Contract / Freelance", "Internship", "Apprenticeship",
];

export const LOCATION_TYPES = ["On-site", "Hybrid", "Remote"];

export const JOB_STATUSES = ["active", "draft", "closed"];
